import { Badge, Divider, Label } from '@vinted/web-ui';
import { useSelector } from 'react-redux';
import SeparatedList from 'components/SeparatedList';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { DONATIONS_SETTINGS_URL, GO_TO_WALLET_URL, MEMBER_PROFILE_URL, PROFILE_SETTINGS_URL, REFERRALS_URL, ROOT_URL, USER_PERSONALIZATION_SIZES_URL, WALLET_INVOICES_URL, MY_ORDERS_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { logoutUser } from 'data/api/account';
import { donationsClickEvent } from 'libs/common/event-tracker/events';
import { navigateToPage } from 'libs/utils/window';
import { OrdersType } from 'constants/my-orders';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getShowFundraiser, getIsReferralsEnabled } from 'state/selectors';
import useShouldShowDarkModeAdoption from 'hooks/useShouldShowDarkModeBanner';
import AccountLink from './AccountLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const AccountLinks = _ref => {
  let {
    userId
  } = _ref;
  const translate = useTranslate();
  const {
    track
  } = useTracking();
  const isPaymentsEnabled = useSelector(getIsFeatureSwitchEnabled('payments'));
  const isMyOrdersNavAndFiltersEnabled = useSelector(getIsFeatureSwitchEnabled('my_orders_nav_and_filters'));
  const isMyOrdersEnabled = useSelector(getIsFeatureSwitchEnabled('next_page_my_orders'));
  const showFundraiser = useSelector(getShowFundraiser);
  const isReferralsEnabled = useSelector(getIsReferralsEnabled);
  const shouldShowDarkModeAdoption = useShouldShowDarkModeAdoption();

  const handleLogoutClick = async () => {
    const response = await logoutUser();
    if (response) navigateToPage(ROOT_URL);
  };

  const handleFundraiserClick = () => {
    track(donationsClickEvent({
      target: ClickableElement.EnterDonationsFromWebMenu
    }));
  };

  const renderSettingsSuffix = () => {
    if (!shouldShowDarkModeAdoption) return null;
    return /*#__PURE__*/_jsx(Badge, {
      theme: "primary",
      content: translate('common.new_badge')
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Label, {
      styling: Label.Styling.Wide,
      text: translate('header.user_menu.account.title')
    }), /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Divider, {}),
      children: [/*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.profile.title'),
        url: MEMBER_PROFILE_URL(userId)
      }), /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.settings.title'),
        url: PROFILE_SETTINGS_URL,
        suffix: renderSettingsSuffix(),
        testId: "settings-account-link"
      }), /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.personalization.title'),
        url: USER_PERSONALIZATION_SIZES_URL
      }), isPaymentsEnabled && /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.wallet.title'),
        url: GO_TO_WALLET_URL
      }), isMyOrdersEnabled && /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.my_orders.title'),
        url: MY_ORDERS_URL({
          type: isMyOrdersNavAndFiltersEnabled ? OrdersType.Sold : OrdersType.All
        })
      }), showFundraiser && /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.donations.title'),
        url: DONATIONS_SETTINGS_URL,
        onClick: handleFundraiserClick
      }), !isPaymentsEnabled && /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.invoices.title'),
        url: WALLET_INVOICES_URL
      }), isReferralsEnabled && /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.referrals.title'),
        url: REFERRALS_URL
      }), /*#__PURE__*/_jsx(AccountLink, {
        title: translate('header.user_menu.account.items.logout.title'),
        onClick: handleLogoutClick
      })]
    })]
  });
};

export default AccountLinks;